import {
  CheckCircleIcon,
  XCircleIcon,
  ClockIcon,
  ExclamationTriangleIcon,
  MinusCircleIcon,
} from '@heroicons/react/24/outline'

export function formatDateTime(ts) {
  if (!ts) return '—'
  return new Date(ts).toLocaleString()
}

export function formatTradingDay(iso) {
  if (!iso) return '—'
  const d = new Date(`${iso}T12:00:00`)
  return d.toLocaleDateString(undefined, { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' })
}

export function formatBytes(n) {
  if (n == null || n === 0) return '—'
  if (n < 1024) return `${n} B`
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`
  return `${(n / (1024 * 1024)).toFixed(1)} MB`
}

export function formatNumber(n) {
  if (n == null) return '—'
  return Number(n).toLocaleString()
}

const IMPORT_MODE_LABELS = {
  single_file: 'Single Azure file',
  all_batches: 'All batches for trading day',
  yesterday: 'Yesterday (scheduled offset)',
  trading_day_single: 'Best match for trading day',
}

export function importModeLabel(mode) {
  return IMPORT_MODE_LABELS[mode] || mode || '—'
}

export function statusBadge(status) {
  const map = {
    ingested: { cls: 'bg-green-100 text-green-800', label: 'Ingested', Icon: CheckCircleIcon },
    success: { cls: 'bg-green-100 text-green-800', label: 'Success', Icon: CheckCircleIcon },
    missing: { cls: 'bg-amber-100 text-amber-800', label: 'Not ingested', Icon: ExclamationTriangleIcon },
    failed: { cls: 'bg-red-100 text-red-800', label: 'Failed', Icon: XCircleIcon },
    partial: { cls: 'bg-yellow-100 text-yellow-800', label: 'Partial', Icon: ExclamationTriangleIcon },
    skipped: { cls: 'bg-gray-100 text-gray-700', label: 'Skipped', Icon: MinusCircleIcon },
    disabled: { cls: 'bg-gray-100 text-gray-600', label: 'Disabled', Icon: MinusCircleIcon },
    coming_soon: { cls: 'bg-slate-100 text-slate-600', label: 'Coming soon', Icon: ClockIcon },
    running: { cls: 'bg-blue-100 text-blue-800', label: 'Running', Icon: ClockIcon },
  }
  const entry = map[status] || { cls: 'bg-gray-100 text-gray-700', label: status || 'Unknown', Icon: MinusCircleIcon }
  const { cls, label, Icon } = entry
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium ${cls}`}>
      <Icon className="w-3.5 h-3.5" />
      {label}
    </span>
  )
}

export function feedStatusColor(status) {
  switch (status) {
    case 'ingested': return 'border-green-200 bg-green-50'
    case 'failed': return 'border-red-200 bg-red-50'
    case 'missing': return 'border-amber-200 bg-amber-50'
    case 'disabled': return 'border-gray-200 bg-gray-50'
    case 'coming_soon': return 'border-slate-200 bg-slate-50 opacity-75'
    default: return 'border-gray-200 bg-white'
  }
}
